import { defineMessages } from 'react-intl'

export const commonLang = defineMessages({
  somethingWrong: {
    id: 'donater.global.something_wrong',
    defaultMessage: 'Oops! Something went wrong. Please try again later.',
  },
})
